import Vue from 'vue';
import Router from 'vue-router';
import BaseConfig from '../baseConfig';

Vue.use(Router);
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/dashboard'
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: resolve => require(['../views/dashboard/home1.vue'], resolve),
            meta: {
                title: '首页概览',
                showProjectTree: true,
            },
        },
        { //项目首页
            path: '/index',
            name: 'index',
            component: resolve => require(['../views/indexpage.vue'], resolve),
            meta: {
                title: '首页概览',
                isMultiple: false
            }
        },
        {
            path:'/alarmBoard',
            name:'alarmBoard',
            component: resolve => require(['../views/alarmBoard/alarm-board.vue'], resolve),
            meta:{
              title:'报警看板'
            }
          },
        {
            path: '/auto-login',
            component: () => import('../components/page/AutoLogin.vue'),
            hidden: true,
            meta: {
                title: '页面跳转中...', // 标题
                keepAlive: true, // 需要被缓存
            },
        },
        // 设备监控
        {
            path: '/',
            component: resolve => require(['../components/common/home.vue'], resolve),
            meta: {
                title: '设备监控'
            },
            children: [
                {
                    path: '/groupControl',
                    component: resolve => require(['@/components/layout/container.vue'], resolve),
                    meta: {
                        title: '云控微断',
                    },
                    children: [
                        {
                            path: '/airMonitoring',
                            name: 'airMonitoring',
                            component: resolve => require(['../views/equipmentAndEnergySaving/groupControl/lightMonitoring/index.vue'], resolve),
                            meta: {
                                title: '设备监控',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                        {
                            path: '/interControl',
                            component: resolve => require(['../views/equipmentAndEnergySaving/groupControl/interControl/index.vue'], resolve),
                            meta: {
                                title: '智能控制',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                        {
                            path: '/applicationWork',
                            component: resolve => require(['../views/equipmentAndEnergySaving/groupControl/applicationWork/index.vue'], resolve),
                            meta: {
                                title: '加班申请',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                        {
                            path: '/controlLog',
                            component: resolve => require(['../views/equipmentAndEnergySaving/groupControl/controlLog/index.vue'], resolve),
                            meta: {
                                title: '控制记录',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                        {
                            path: '/equpmentAnalyse',
                            component: resolve => require(['../views/equipmentAndEnergySaving/groupControl/equpmentAnalyse/index.vue'], resolve),
                            meta: {
                                title: '设备分析',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                        {
                            path: '/oprateStatistic',
                            component: resolve => require(['../views/equipmentAndEnergySaving/groupControl/oprateStatistic/index.vue'], resolve),
                            meta: {
                                title: '运行统计',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                    ]
                },
                {
                    path: '/coldMonitoring',
                    name: 'coldMonitoring',
                    component: resolve => require(['../views/equMonitoring/coldMonitoring/index.vue'], resolve),
                    meta: {
                        title: '冷站控制',
                        showProjectTree: true,
                        isMultiple: false
                    }
                },
                {
                    name: 'refrigeration-cost-analysis',
                    path: '/refrigeration-cost-analysis',
                    component: resolve => require(['../views/equMonitoring/refrigeration-cost-analysis/index.vue'], resolve),
                    meta: {
                      title: '制冷费用分析'
                    }
                },
                {
                    name: 'performance-diagnosis',
                    path: '/performance-diagnosis',
                    component: resolve => require(['../views/equMonitoring/performance-diagnosis/index.vue'], resolve),
                    meta: {
                      title: '运行诊断'
                    }
                },
                {
                    name: 'energyComsumptionAnalysis',
                    path: '/energyComsumptionAnalysis',
                    component: resolve => require(['../views/equMonitoring/energyComsumptionAnalysis/index.vue'], resolve),
                    meta: {
                      title: '运行统计-能效分析'
                    }
                },
                {
                  name: 'cold-energy-efficiency',
                  path: '/cold-energy-efficiency',
                  component:resolve => require(['../views/equMonitoring/cold-energy-efficiency/index.vue'],resolve),
                  meta: {
                      title: '冷站能效',
                  },
                },
                // 临时模拟用的
                {
                    path: '/3DModel',
                    name: '3DModel',
                    component: resolve => require(['../views/equMonitoring/coldMonitoring/3DModel.vue'], resolve),
                    meta: {
                        title: '三维展示',
                        showProjectTree: true,
                        isMultiple: false
                    }
                },
                {
                    path: '/windCold',
                    name: 'windCold',
                    component: resolve => require(['../views/equMonitoring/windCold/index.vue'], resolve),
                    meta: {
                        title: '风冷控制',
                        showProjectTree: true,
                        isMultiple: false,
                        isWindCold: true,
                    }
                },
                // {
                //     path: '/splitAir',
                //     name: 'splitAir',
                //     component: resolve => require(['../views/equMonitoring/splitAir/index.vue'], resolve),
                //     meta: {
                //         title: '末端分体空调',
                //         showProjectTree: true,
                //         isMultiple: false,
                //         // isWindCold:true,
                //     }
                // },
                // 瑞斯康分体空调
                {
                    path: '/split-air',
                    name: 'split-air',
                    component: resolve => require(['@/components/layout/container.vue'], resolve),
                    meta: {
                        title: '分体空调',
                    },
                    children:[
                        {
                            path: '/splitAir',
                            name: 'splitAir',
                            component: resolve => require(['../views/equMonitoring/ruiSplitAir/index.vue'], resolve),
                            meta: {
                                title: '分体空调',
                                showProjectTree: true,
                                isMultiple: false,
                            }
                        },
                        {
                            path: '/ruiDataList',
                            component: resolve => require(['../views/equMonitoring/ruiDataList/index.vue'], resolve),
                            meta: {
                                title: '数据列表',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                    ]
                }, 
                {
                    path: '/lightMonitoring',
                    name: 'lightMonitoring',
                    component: resolve => require(['@/components/layout/container.vue'], resolve),
                    meta: {
                        title: '照明监控',
                    },
                    children: [
                        {
                            path: '/light-monitor',
                            component: resolve => require(['../views/equMonitoring/lightMonitoring/monitoring/index.vue'], resolve),
                            meta: {
                                title: '照明监控',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                        {
                            path: '/lightList',
                            component: resolve => require(['../views/equMonitoring/lightMonitoring/data-list/index.vue'], resolve),
                            meta: {
                                title: '数据列表',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                    ]
                },
                {
                    path: '/taskCenter',
                    name: 'taskCenter',
                    component: resolve => require(['../views/equMonitoring/taskCenter/index.vue'], resolve),
                    meta: {
                        title: '任务中心',
                        showProjectTree: true,
                        isMultiple: false,
                    }
                },
                {
                    path: '/energyConservationStatistics',
                    name: 'energyConservationStatistics',
                    component: resolve => require(['../views/equMonitoring/energyConservationStatistics/index.vue'], resolve),
                    meta: {
                        title: '节能统计',
                        showProjectTree: true,
                        isMultiple: false,
                    }
                },
                {
                    path: '/heatMonitoring',
                    name: 'heatMonitoring',
                    component: resolve => require(['../views/equMonitoring/heatMonitoring/index.vue'], resolve),
                    meta: {
                        title: '采暖控制',
                        showProjectTree: true,
                        isMultiple: false,
                    }
                },
                {
                    name: 'hotWater',
                    path: '/hotWater',
                    component: resolve => require(['../views/equMonitoring/hotWater/index.vue'], resolve),
                    meta: {
                      title: '热水监控'
                    }
                },
                {
                    path: '/endMonitoring',
                    name: 'endMonitoring',
                    component: resolve => require(['@/components/layout/container.vue'], resolve),
                    meta: {
                        title: '末端监控',
                    },
                    children: [
                        {
                            path: '/end-monitor',
                            name:'end-monitor',
                            component: resolve => require(['../views/equMonitoring/endMonitoring/monitoring/index.vue'], resolve),
                            meta: {
                                title: '末端监控',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                        {
                            path: '/endList',
                            name: 'end-data-list',
                            component: resolve => require(['../views/equMonitoring/endMonitoring/data-list/index.vue'], resolve),
                            meta: {
                                title: '数据列表',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                    ]
                },
                // {
                //     path: '/vrvMonitoring',
                //     name:'vrvMonitoring',
                //     component: resolve => require(['@/components/layout/container.vue'], resolve),
                //     meta: {
                //         title: 'VRV监控',
                //     },
                //     children:[
                //         {
                //             path: '/vrv-monitorring',
                //             component: resolve => require(['../views/equMonitoring/vrvMonitoring/monitoring/index.vue'], resolve),
                //             meta: {
                //               title: 'VRV监控',
                //               showProjectTree: true,
                //                 isMultiple:false
                //             },
                //       },
                //       {
                //             path: '/vrv-data-list',
                //             component: resolve => require(['../views/equMonitoring/vrvMonitoring/dataList/index.vue'], resolve),
                //             meta: {
                //               title: '数据列表',
                //               showProjectTree: true,
                //               isMultiple:false
                //             },
                //       },
                //     ]
                // },
                {
                    path: '/operationLog',
                    component: resolve => require(['../views/equMonitoring/operation-log/index.vue'], resolve),
                    meta: {
                        title: '智控日志',
                        showProjectTree: true,
                        isMultiple: false
                    }
                },
                {
                    path: '/runningRecords',
                    name: 'runningRecords',
                    component: resolve => require(['../views/equMonitoring/runningRecords/index.vue'], resolve),
                    meta: {
                        title: '运行记录',
                        showProjectTree: true,
                        isMultiple: false,
                    }
                },
            ]
        },
        // 可再生能源
        {
            path:'/renewableEnergy',
            component: resolve => require(['../components/common/home.vue'], resolve),
            meta: {
                title: '可再生能源'
            },
            children:[
                {
                    name: 'overview',
                    path: '/overview',
                    component: resolve => require(['../views/renewableEnergy/overview/index.vue'], resolve),
                    meta: {
                      title: '光伏概览',
                      showProjectTree: true,
                      isMultiple: false,
                    }
                  },
                  {
                    name: 'sys-info',
                    path: '/sysInfo',
                    component: () => import('@/components/layout/container.vue'),
                    meta: {
                      title: '光伏系统',
                      showProjectTree: true,
                      isMultiple: false,
                    },
                    children: [
                      {
                        path: '/sysArchitecture',
                        component: resolve => require(['../views/renewableEnergy/sys-info/sys-architecture/index.vue'], resolve),
                        meta: {
                          title: '逻辑视图',
                          showProjectTree: true,
                          isMultiple: false,
                        }
                      },
                    ]
                  },
                  {
                    name: 'photovoltaics',
                    path: '/photovoltaics',
                    component: resolve => require(['../views/renewableEnergy/photovoltaics/index.vue'], resolve),
                    meta: {
                      title: '设备参数',
                      showProjectTree: true,
                      isMultiple: false,
                    }
                  },
                  {
                    name: 'device-analysis',
                    path: '/deviceAnalysis',
                    component: resolve => require(['../views/renewableEnergy/device-analysis/index.vue'], resolve),
                    meta: {
                      title: '设备分析',
                      showProjectTree: true,
                      isMultiple: false,
                    }
                  },
            ]
        },
        // 能耗分析
        {
            path: '/',
            component: resolve => require(['../components/common/home.vue'], resolve),
            meta: {
                title: '能耗分析'
            },
            children: [
                {
                    path: '/pmDistribution',
                    component: resolve => require(['../views/pmDistribution/index.vue'], resolve),
                    meta: {
                        title: '项目分布',
                        showProjectTree: false,
                        isMultiple: false
                    }
                },
                {
                    path: '/energyConsumptionQuery',
                    component: resolve => require(['../views/energyAnalysis/energyConsumptionQuery/newEnergyConsumptionQuery.vue'], resolve),
                    meta: {
                        title: '能耗查询',
                        showProjectTree: true,
                        isMultiple: false
                    }
                },
                {
                    path: '/thermodynamicChart',
                    component: resolve => require(['../views/energyAnalysis/thermodynamicChart/index.vue'], resolve),
                    meta: {
                        title: '热力图',
                        showProjectTree: true,
                        isMultiple: false
                    }
                },
                {
                    path: '/energyMap',
                    component: resolve => require(['../views/energyAnalysis/energyFlow/index.vue'], resolve),
                    meta: {
                        title: '能流图',
                        showProjectTree: true,
                        isMultiple: false
                    }
                },
                {
                    path: '/loadPrediction',
                    component: resolve => require(['../views/energyAnalysis/loadPrediction/loadPrediction.vue'], resolve),
                    meta: {
                        title: '能耗预测',
                        showProjectTree: true,
                        isMultiple: false
                    }
                },
                {
                    path: '/quota',
                    name: 'quota',
                    component: resolve => require(['../views/quota/quotamanagement/quotamanagement.vue'], resolve),
                    meta: {
                        title: '项目定额',
                        showProjectTree: true,
                        isMultiple: false
                    }
                },
                {
                    path: '/energySaving',
                    name: 'energySaving',
                    component: resolve => require(['@/components/layout/container.vue'], resolve),
                    meta: {
                        title: '节能指标',
                        showProjectTree: true,
                        isMultiple: false
                    },
                    children: [
                        {
                            path: '/energySavingAnalysis',
                            name: 'energySavingAnalysis',
                            component: resolve => require(['../views/costForEnergy/energy-saving-management/index.vue'], resolve),
                            meta: {
                                title: '节能量分析',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                        {
                            path: '/energySavingAudit',
                            component: resolve => require(['../views/energySavingAudit/index.vue'], resolve),
                            meta: {
                                title: '节能审计归档',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                    ]
                },
                {
                    path: '/energySavingStatementQuery',
                    name: 'energySavingStatementQuery',
                    component: resolve => require(['@/components/layout/container.vue'], resolve),
                    meta: {
                        title: '自定义报表',
                        showProjectTree: true,
                        isMultiple: false
                    },
                    children: [
                        {
                            path: '/statementQuery',
                            name: 'statementQuery',
                            component: resolve => require(['../views/energyAnalysis/statementQuery/index.vue'], resolve),
                            meta: {
                                title: '报表查询',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                        {
                            path: '/reportTemplate',
                            component: resolve => require(['../views/energyAnalysis/reportTemplate/index.vue'], resolve),
                            meta: {
                                title: '报表模板',
                                showProjectTree: true,
                                isMultiple: false
                            },
                        },
                    ]
                },

            ]
        },
        // 数据采集
        {
            path: '/',
            component: resolve =>
                require(['../components/common/home.vue'], resolve),
            meta: {
                title: '数据采集'
            },
            children: [
                {
                    path: '/autoMeterReading',
                    component: resolve =>
                        require([
                            '../views/energyConsumptionReport/meterReading/branchMeterReading.vue'
                        ], resolve),
                    meta: {
                        title: '自动抄表',
                        showProjectTree: true,
                        isMultiple: false
                    }
                },
                {
                    path: '/dataEntry',
                    component: resolve => require(['@/components/layout/container.vue'], resolve),
                    meta: {
                        title: '人工数据采集',
                        showProjectTree: true,
                        isMultiple: true
                    },
                    children: [
                        {
                            path: '/dataCollection',
                            component: resolve => require(['../views/energyAnalysis/dataEntry/dataCollection/index.vue'], resolve),
                            meta: {
                                title: '数据采集',
                                showProjectTree: true,
                                isMultiple: true
                            },
                        },
                        {
                            path: '/dataEntering',
                            component: resolve => require(['../views/energyAnalysis/dataEntry/dataEntering/index.vue'], resolve),
                            meta: {
                                title: '数据录入',
                                showProjectTree: true,
                                isMultiple: true
                            },
                        },
                        {
                            path: '/dataRecord',
                            component: resolve => require(['../views/energyAnalysis/dataEntry/dataRecord/index.vue'], resolve),
                            meta: {
                                title: '操作记录',
                                showProjectTree: true,
                                isMultiple: true
                            },
                        },
                    ]
                },
                {
                    path: '/billManagement',
                    component: resolve => require(['../views/costForEnergy/billManagement.vue'], resolve),
                    meta: {
                        title: '电费单管理',
                        showProjectTree: true,
                        isMultiple: false,
                    }
                },
                {
                    path: '/meterMonitoring',
                    component: resolve => require(['../views/equipmentMonitoring/meterMonitoring.vue'], resolve),
                    meta: {
                        title: '采集器在线',
                        showProjectTree: true,
                        isMultiple: false,
                    }
                },
                {
                    path: '/meterReading',
                    component: resolve => require(['../views/equipmentMonitoring/meterReading.vue'], resolve),
                    meta: {
                        title: '表计读数',
                        showProjectTree: true,
                        isMultiple: false,
                    }
                },
            ]
        },
        // 碳监测
        {
            path: '/',
            component: resolve => require(['../components/common/home.vue'], resolve),
            meta: {
                title: '碳监测管理'
            },
            children: [{
                path: '/carbonPublic',
                name: 'carbonPublic',
                component: resolve => require(['../views/carbonMonitoring/carbonPublic/index.vue'], resolve),
                meta: {
                    title: '碳公示看板',
                    showProjectTree: true,
                    isMultiple: true
                }
            },
            {
                path: '/carbonMonitoring',
                name: 'carbonMonitoring',
                component: resolve => require(['../views/carbonMonitoring/index.vue'], resolve),
                meta: {
                    title: '碳排放监测',
                    showProjectTree: true,
                    isMultiple: true
                }
            },
            {
                path: '/carbonDetection',
                name: 'carbonDetection',
                component: resolve => require(['../views/carbonMonitoring/CarbonDetection/index.vue'], resolve),
                meta: {
                    title: '减碳监测',
                    showProjectTree: true,
                    isMultiple: true
                }

            },
            {
                path: '/carbonReduction',
                component: resolve => require(['../views/carbonMonitoring/carbonReduction/index.vue'], resolve),
                meta: {
                    title: '节能减碳',
                    showProjectTree: true,
                    isMultiple: false
                }
            },
            {
                name: 'carbon-drop-analyse',
                path: '/carbonDropAnalyse',
                component: resolve => require(['../views/carbonMonitoring/carbonDropAnalyse/index.vue'], resolve),
                meta: {
                    title: '降碳分析',
                    showProjectTree: true,
                    isMultiple: false
                }
            },
            {
                path: "/carbonemission",
                name: 'carbonemission',
                component: resolve => require(['../views/carbonMonitoring/CarbonEmission/index.vue'], resolve),
                meta: {
                    title: '净碳排放',
                    showProjectTree: true,
                    isMultiple: true
                }
            },
            {
                path: '/carbonDataEnter',
                component: resolve => require(['../views/carbonMonitoring/carbonDataEnter/index.vue'], resolve),
                meta: {
                    title: '数据录入',
                    showProjectTree: true,
                    isMultiple: true
                }
            },
            {
                path: '/carbonSetInfo',
                component: resolve => require(['../views/carbonMonitoring/carbonSetInfo/index.vue'], resolve),
                meta: {
                    title: '信息设置',
                    showProjectTree: false,
                }
            },
            ]
        },
        {
            path: '/',
            component: resolve =>
                require(['../components/common/home.vue'], resolve),
            meta: {
                title: '报警管理'
            },
            children: [{
                path: '/',
                component: resolve => require(['@/components/layout/container.vue'], resolve),
                meta: {
                    title: '报警概览',
                    showProjectTree: true,
                    isMultiple: false
                },
                children: [
                    {
                        name: 'alarmView',
                        path: '/alarmView',
                        component: resolve => require(['../views/alarmManagement/deviceAlarm/AlarmView.vue'], resolve),
                        meta: {
                            title: '报警概览',
                            showProjectTree: true,
                            isMultiple: false
                        },
                    },
                    {
                        name: 'otherOverview',
                        path: '/otherOverview',
                        component: resolve => require(['../views/alarmManagement/otherOverview.vue'], resolve),
                        meta: {
                            title: '能耗报警',
                            showProjectTree: true,
                            isMultiple: false
                        },
                    }
                ]
            },
            {
                path: '/selfDefinedAlarm',
                component: resolve => require(['../views/alarmManagement/selfDefinedAlarm/selfDefinedAlarm.vue'], resolve),
                meta: {
                    title: '自定义报警',
                    showProjectTree: true,
                    isMultiple: false
                }
            },
            {
                path: '/new-alarm',
                component: (resolve) =>
                    require([
                        '@/views/alarmManagement/selfDefinedAlarm/NewAlarm.vue',
                    ], resolve),
                meta: {
                    title: '新增自定义报警',
                    showProjectTree: true, //显示项目树
                    isMultiple: false
                },
            },
            {
                path: '/',
                component: resolve =>
                    require([
                        '@/components/layout/container.vue'
                    ], resolve),
                meta: {
                    title: '报警推送',
                    showProjectTree: true,
                    isMultiple: false
                },
                children: [
                    {
                        name: 'Msgconfigure',
                        path: '/Msgconfigure',
                        component: resolve => require(['../views/basicInfomations/pushSettings/MsgConfigure.vue'], resolve),
                        meta: {
                            title: '推送配置',
                            showProjectTree: true,
                            isMultiple: false
                        },
                    },
                    {
                        name: 'MsgRecord',
                        path: '/msgRecord',
                        component: resolve => require(['../views/basicInfomations/pushSettings/MsgRecord.vue'], resolve),
                        meta: {
                            title: '推送记录',
                            showProjectTree: true,
                            isMultiple: false
                        },
                    }
                ]
            },
            ]
        },

        // 能耗统计
        {
            path: '/',
            component: resolve => require(['../components/common/home.vue'], resolve),
            meta: {
                title: '能耗统计'
            },
            children: [
                {
                    path: '/energyEfficiency',
                    component: resolve => require(['@/components/layout/container.vue'], resolve),
                    meta: {
                        title: '能耗公示',
                        showProjectTree: false
                    },
                    children: [
                        {
                            path: '/energyPublic',
                            component: resolve => require(['../views/energyAnalysis/energyEfficiency/energyPublic.vue'], resolve),
                            meta: {
                                title: '能效公示',
                                showProjectTree: false
                            },
                        },
                        {
                            path: '/energyManage',
                            component: resolve => require(['../views/energyAnalysis/energyEfficiency/energyManage.vue'], resolve),
                            meta: {
                                title: '公示管理',
                                showProjectTree: false
                            },
                        },
                    ]
                },
                {
                    path: '/energyConsumptionRanking',
                    component: resolve => require(['../views/energyAnalysis/energyConsumptionRanking/energyConsumptionRanking.vue'], resolve),
                    meta: {
                        title: '能耗排名',
                        showProjectTree: false
                    }
                },
                {
                    path: '/energyConsumptionComparison',
                    component: resolve => require(['../views/energyAnalysis/energyConsumptionComparison/newEnergyConsumptionComparison.vue'], resolve),
                    meta: {
                        title: '能耗对比',
                        showProjectTree: true,
                        isMultiple: false
                    }
                },
                {
                    path: '/energyConsumptionReport',
                    component: resolve => require(['../views/energyConsumptionReport/energyConsumptionReport.vue'], resolve),
                    meta: {
                        title: '统计报表',
                    }
                },
                {
                    path: '/analysisReport',
                    component: resolve =>
                        require([
                            '../views/energyConsumptionReport/analysisReport/analysisReport.vue'
                        ], resolve),
                    meta: {
                        title: '诊断报告',
                        showProjectTree: true,
                        isMultiple: false
                    }
                },
            ]
        },
        // 平台配置
        {
            path: '/',
            component: resolve => require(['../components/common/home.vue'], resolve),
            meta: {
                title: '平台配置'
            },
            children: [
                {
                    path: '/',
                    component: resolve => require(['../components/common/subhome.vue'], resolve),
                    meta: {
                        title: '用户管理'
                    },
                    children: [
                        {
                            path: '/adminUserList',
                            component: resolve => require(['../views/platformConfiguration/adminUser/adminUserList.vue'], resolve),
                            meta: {
                                title: '用户列表'
                            }
                        },
                        {
                            path: '/adminRoleList',
                            component: resolve => require(['../views/platformConfiguration/role/roleList.vue'], resolve),
                            meta: {
                                title: '角色列表'
                            }
                        },
                        {
                            path: '/perssionList',
                            component: resolve => require(['../views/platformConfiguration/perssion/perssionList.vue'], resolve),
                            meta: {
                                title: '权限列表'
                            }
                        },
                        {
                            path: '/adminOperationLog',
                            component: resolve => require(['../views/platformConfiguration/adminOperationLog.vue'], resolve),
                            meta: {
                                title: '操作日志'
                            }
                        },
                    ]
                },
                {
                    path: '/',
                    component: resolve => require(['../components/common/subhome.vue'], resolve),
                    meta: {
                        title: '基础信息'
                    },
                    children: [
                        {
                            path: '/projectList',
                            component: resolve => require(['../views/basicInfomations/project/projectList.vue'], resolve),
                            meta: {
                                title: '项目管理'
                            }
                        },
                        {
                            path: '/departmentStaff',
                            component: resolve => require(['../views/basicInfomations/departmentStaff/departmentStaff.vue'], resolve),
                            meta: {
                                title: '部门管理'
                            }
                        },
                        {
                            path: '/roomManagement',
                            component: resolve => require(['../views/basicInfomations/roomManage/index.vue'], resolve),
                            meta: {
                                title: '房间管理',
                                showProjectTree: true,
                            }
                        },
                        {
                            path: '/conversionEnergy',
                            component: resolve => require(['../views/basicInfomations/conversionEnergy/conversionEnergy.vue'], resolve),
                            meta: {
                                title: '能耗指标换算'
                            }
                        },
                        {
                            path: '/timeSet',
                            component: resolve => require(['../views/basicInfomations/timeSet/timeSetList.vue'], resolve),
                            meta: {
                                title: '分时电价设置'
                            }
                        },
                        {
                            path: '/workingCalendar',
                            component: resolve => require(['../views/basicInfomations/workingCalendar.vue'], resolve),
                            meta: {
                                title: '工作日历'
                            }
                        },
                    ]
                },
                {
                    path: '/',
                    component: resolve => require(['../components/common/subhome.vue'], resolve),
                    meta: {
                        title: '系统设置'
                    },
                    children: [
                        {
                            path: '/branchManagement',
                            name: 'branchManagement',
                            component: resolve => require(['../views/systemSeting/branchManagement/branchManagement.vue'], resolve),
                            meta: {
                                title: '支路管理'
                            }
                        },
                        {
                            path: '/dataBackup',
                            component: resolve => require(['../views/systemSeting/dataBackup/index.vue'], resolve),
                            meta: {
                                title: '数据备份'
                            }
                        },
                        {
                            path: '/dataUpload',
                            component: resolve => require(['../views/systemSeting/dataUpload/index.vue'], resolve),
                            meta: {
                                title: '数据上传'
                            }
                        },
                        {
                            path: '/collectorManagement',
                            component: resolve => require(['../views/systemSeting/collectorManagement/CollectorManagement.vue'], resolve),
                            meta: {
                                title: '采集器管理'
                            }
                        },
                        {
                            path: '/componentModel',
                            component: resolve => require(['../views/systemSeting/componentModel/componentModel.vue'], resolve),
                            meta: {
                                title: '分项模型'
                            }
                        },
                        {
                            path: '/equManage',
                            component: resolve => require(['@/components/layout/container.vue'], resolve),
                            meta: {
                                title: '设备管理',
                                showProjectTree: true
                            },
                            children: [
                                {
                                    path: '/deviceManage',
                                    name: 'deviceManage',
                                    component: resolve => require(['../views/systemSeting/equManage/deviceManage/index.vue'], resolve),
                                    meta: {
                                        title: '设备管理',
                                        showProjectTree: true
                                    },
                                },
                                {
                                    path: '/sysImg',
                                    component: resolve => require(['../views/systemSeting/equManage/sysImg/index.vue'], resolve),
                                    meta: {
                                        title: '系统图',
                                        showProjectTree: true
                                    },
                                },
                                {
                                    path: '/monitorPage',
                                    component: resolve => require(['../views/systemSeting/equManage/monitorPage/index.vue'], resolve),
                                    meta: {
                                        title: '监控界面',
                                        showProjectTree: true
                                    },
                                },
                                {
                                    path: '/design',
                                    name:'design',
                                    component: resolve => require(['../views/systemSeting/equManage/design/index.vue'], resolve),
                                    meta: {
                                        title: '设计器',
                                        showProjectTree: true
                                    },
                                },
                                // 下面两个页面是瑞斯康分体空调适配的页面
                                {
                                    path: '/airMonitorPage',
                                    component: resolve => require(['../views/systemSeting/equManage/airMonitorPage/index.vue'], resolve),
                                    meta: {
                                        title: '分体空调监控界面',
                                        showProjectTree: true
                                    },
                                },
                                {
                                    path: '/airdeviceManage',
                                    component: resolve => require(['../views/systemSeting/equManage/airdeviceManage/index.vue'], resolve),
                                    meta: {
                                        title: '分体空调设备管理',
                                        showProjectTree: true
                                    },
                                }
                            ]
                        },
                        {
                            path: '/meterParameter',
                            component: resolve => require(['../views/systemSeting/meterParameter/meterParameter.vue'], resolve),
                            meta: {
                                title: '表计参数'
                            }
                        },
                        {
                            path: '/systemGlobalParameterConfiguration',
                            component: resolve => require(['../views/systemSeting/systemGlobalParameterConfiguration/systemGlobalParameterConfiguration.vue'], resolve),
                            meta: {
                                title: '系统全局参数配置'
                            }
                        },
                        {
                            path: '/quotaStandards',
                            component: resolve => require(['../views/systemSeting/quotaStandards/quotaStandards.vue'], resolve),
                            meta: {
                                title: '行业标准'
                            }
                        },
                        {
                            path: '/weatherTemperature',
                            component: resolve => require(['../views/systemSeting/weatherTemperature.vue'], resolve),
                            meta: {
                                title: '城区温度'
                            }
                        },
                        {
                            path: '/platConfiguration',
                            component: resolve => require(['../views/systemSeting/platConfiguration/index.vue'], resolve),
                            meta: {
                                title: '平台基础配置'
                            }
                        },
                        {
                            path: '/informationBulletin',
                            component: resolve => require(['../views/systemSeting/informationBulletin/informationBulletin.vue'], resolve),
                            meta: {
                                title: '信息公告',
                                showProjectTree: true,
                                isMultiple: false
                            }
                        },
                        {
                            path: '/systemOperationSituationAnalysis',
                            component: resolve => require(['../views/systemSeting/systemOperationSituationAnalysis/systemOperationSituationAnalysis.vue'], resolve),
                            meta: {
                                title: '资源调度'
                            }
                        },
                    ]
                },
                {
                    path: '/',
                    component: resolve => require(['../components/common/subhome.vue'], resolve),
                    meta: {
                        title: '数据校核'
                    },
                    children: [
                        {
                            path: '/branchEnergyConsumption',
                            component: resolve => require(['../views/dataCollations/branchEnergyConsumption/branchEnergyConsumption.vue'], resolve),
                            meta: {
                                title: '支路能耗校核'
                            }
                        },
                        {
                            path: '/branchInfo',
                            component: resolve => require(['../views/dataCollations/branchInfo/branchInfo.vue'], resolve),
                            meta: {
                                title: '支路信息校核'
                            }
                        },
                        {
                            path: '/readingQuery',
                            component: resolve => require(['../views/dataCollations/ReadingQuery/readingQuery.vue'], resolve),
                            meta: {
                                title: '表头读数查询'
                            }
                        },
                        {
                            path: '/reportDownload',
                            component: resolve => require(['../views/dataCollations/reportDownload.vue'], resolve),
                            meta: {
                                title: '校对报告下载'
                            }
                        },
                        {
                            path: '/subentryEnergyConsumption',
                            component: resolve => require(['../views/dataCollations/subentryEnergyConsumption.vue'], resolve),
                            meta: {
                                title: '分项能耗校核'
                            }
                        },
                        {
                            path: '/subitemInfo',
                            component: resolve => require(['../views/dataCollations/subitemInfo/subitemInfo.vue'], resolve),
                            meta: {
                                title: '分项信息校核'
                            }
                        },
                        {
                            path: '/systemDetection',
                            component: resolve => require(['../views/dataCollations/systemDetection/systemDetection.vue'], resolve),
                            meta: {
                                title: '系统检测'
                            }
                        },
                        {
                            path: '/originalDataQuery',
                            component: resolve =>
                                require([
                                    '../views/dataCollations/originalDataQuery/originalData.vue'
                                ], resolve),
                            meta: {
                                title: '原始数据包查询'
                            }
                        },
                    ]
                },
            ]
        },
        // 能源审计
        {
            path: '/',
            component: resolve => require(['../components/common/home.vue'], resolve),
            meta: {
                title: '能源审计'
            },
            children: [
                {
                    path: '/publish',
                    component: resolve => require(['../views/configAudit/publish.vue'], resolve),
                    meta: {
                        title: '审计公示'
                    }
                },
                {
                    path: '/auditManage',
                    component: resolve => require(['../views/configAudit/auditManage.vue'], resolve),
                    meta: {
                        title: '审计管理'
                    }
                },
                {
                    path: '/archive',
                    component: resolve => require(['../views/configAudit/archive.vue'], resolve),
                    meta: {
                        title: '审计归档'
                    }
                }
            ]
        },
        {
            path: '/login',
            component: resolve => require(['../components/page/login.vue'], resolve),
            meta: {
                title: BaseConfig.P_TITLE
            }
        },
        {
            path: '/403',
            component: resolve => require(['../components/page/403.vue'], resolve)
        },
        {
            path: '*',
            redirect: '/404'
        }
    ],
})
